export default __webpack_public_path__ + "static/media/promos-icon-active.f2d8024e.webp";